module.exports = __webpack_public_path__ + "static/media/Ø3(2).c3946ef4.png";